"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = exports.typography = exports.layers = exports.colors = exports.shadows = exports.motion = exports.grid = exports.borders = exports.breakpoints = void 0;
const variables_js_1 = require("./breakpoints/variables.js");
exports.breakpoints = variables_js_1.default;
const variables_js_2 = require("./borders/variables.js");
exports.borders = variables_js_2.default;
const variables_js_3 = require("./grid/variables.js");
exports.grid = variables_js_3.default;
const variables_js_4 = require("./motion/variables.js");
exports.motion = variables_js_4.default;
const variables_js_5 = require("./shadows/variables.js");
exports.shadows = variables_js_5.default;
const variables_js_6 = require("./colors/variables.js");
exports.colors = variables_js_6.default;
const variables_js_7 = require("./layers/variables.js");
exports.layers = variables_js_7.default;
const variables_js_8 = require("./typography/variables.js");
exports.typography = variables_js_8.default;
const variables_js_9 = require("./spacing/variables.js");
exports.spacing = variables_js_9.default;
